import {TypePointer, TypeInt} from './../Parser/TypeDefinition'

function Memory () {
    this.heap = []
    this.stack = []
    this.display = []
}

Memory.prototype = {
    HEAP_START: 100000000,
    incBlock () {
        this.display.push(this.stack.length)
    },
    decrBlock () {
        this.display.pop()
    },
    push (type, value, data) {
        this.stack.push({type, value, data})
    },
    peek () {
        return this.stack[this.stack.length - 1]
    },
    pop () {
        return this.stack.pop()
    },
    alloca (type, size) {
        let addr = this.heap.length
        this.heap[addr] = {
            type: TypeInt(),
            value: size
        }
        for (let i = 0; i < size; i++) {
            this.heap[addr + 1 + i] = {
                type: type,
                value: null
            }
        }
        this.stack.push({
            type: TypePointer(),
            value: this.HEAP_START + addr
        })
    },
    freea (addr, type) {
        let size = this.heap[addr - this.HEAP_START].value
        this.heap[addr - this.HEAP_START].value = null
        for (let i = 0; i <= size; i++) {
            this.heap[addr - this.HEAP_START + i].value = undefined
        }
    },
    read (addr, type) {
        if (addr >= this.HEAP_START) {
            return this.heap[addr - this.HEAP_START]
        }
        return this.stack[this.display[this.display.length - 1] + addr]
    },
    write (addr, type, value) {
        if (addr >= this.HEAP_START) {
            this.heap[addr - this.HEAP_START].type = type
            this.heap[addr - this.HEAP_START].value = value
            return
        }
        this.stack[this.display[this.display.length - 1] + addr].type = type
        this.stack[this.display[this.display.length - 1] + addr].value = value
    },
    readAbs (addr, type) {
        if (addr >= this.HEAP_START) {
            return this.heap[addr - this.HEAP_START]
        }
        return this.stack[addr]
    },
    writeAbs (addr, type, value) {
        if (addr >= this.HEAP_START) {
            this.heap[addr - this.HEAP_START].type = type
            this.heap[addr - this.HEAP_START].value = value
            return
        }
        this.stack[addr].type = type
        this.stack[addr].value = value
    },
    ldref (relativeAddr) {
        this.stack.push({
            type: TypePointer(),
            value: this.display[this.display.length - 1] + relativeAddr
        })
    },
    ldrefa (relativeAddr, index) {
        let arrayAddress = this.stack[this.display[this.display.length - 1] + relativeAddr].value
        this.stack.push({
            type: TypePointer(),
            value: arrayAddress + 1 + index
        })
    },
    arrcpy (type, addr) {
        let arrayBaseAddress = this.stack[this.display[this.display.length - 1] + addr].value - this.HEAP_START
        let newArrayAddress = this.heap.length
        let arraySize = this.heap[arrayBaseAddress].value

        // Copy size
        for (let i = 0; i <= arraySize; i++) {
            this.heap[newArrayAddress + i] = {
                type: this.heap[arrayBaseAddress + i].type.clone(),
                value: this.heap[arrayBaseAddress + i].value
            }
        }

        this.stack.push({
            type: TypePointer(),
            value: this.HEAP_START + newArrayAddress
        })
    },
    _dump () {
        console.log('\nSTART MEMORY DUMP\n')
        console.log('DISPLAY:')
        console.log(JSON.parse(JSON.stringify(this.display)))
        console.log('STACK:')
        console.log(JSON.parse(JSON.stringify(this.stack)))
        console.log('HEAP:')
        console.log(JSON.parse(JSON.stringify(this.heap)))
        console.log('\nEND MEMORY DUMP\n')
    }
}

export default Memory



// WEBPACK FOOTER //
// ./src/Core/VirtualMachine/Memory.js